// extracted by mini-css-extract-plugin
export default {"background":"wrapper_background__Q-jyt"};